import React, { useEffect } from "react";
import { PolicyMenu } from "./menu/PolicyMenu";
import { SocialNetworkLinks } from "./SocialNetworkLinks";
import { useMenuItems } from "./menu/useMenuItems";
import { ProdesegAnnouncement } from "./components/ProdesegAnnouncement/ProdesegAnnouncement";
import { useWindowBreakpoints } from "../../custom-hooks/useWindowBreakpoints";
import { redirectToCotizadorIfNeeded } from "../../util/General";

export const GeneralHome: React.FC = () => {
    const menuItems = useMenuItems();
    const { isUpMd } = useWindowBreakpoints();

    useEffect(() => {
        redirectToCotizadorIfNeeded();
    }, []);
    return (
        <div className={"policy-spacing"}>
            <div className={"container-fluid py-5-3"}>
                <section className="row pb-5-3 pb-md-0">
                    <article className={"col-md-4 col-lg-3"}>
                        <div className={"h-100 d-flex flex-column flex-wrap justify-content-between"}>
                            <div className={"d-flex flex-column gap-2-1"}>
                                <div className={"fw-semibold fs-3"}>Bienvenido a Prodeseg Online.</div>
                                <div className={"fs-2-1"}>
                                    En este ecosistema digital podrás acceder a todos los beneficios exclusivos para los
                                    clientes de Prodeseg. Adicional podrás gestionar tus pólizas, siniestros y más.
                                </div>
                            </div>
                        </div>
                    </article>
                    <article className={"offset-lg-2 col-md-8 col-lg-7 pt-4-2 pt-md-0"}>
                        <PolicyMenu policies={menuItems} />
                    </article>
                </section>
            </div>
            <section className={"social-network"}>
                {isUpMd && <ProdesegAnnouncement />}
                <article className={"d-flex flex-column gap-2-1"}>
                    <div className={"text-neutral-700 fw-medium d-none d-md-block"}>Síguenos en redes:</div>
                    <SocialNetworkLinks />
                </article>
            </section>
        </div>
    );
};
